import React from 'react';
import { useActions } from '../../hooks/useStore';
import AddEventModal from './AddEventModal';

interface AddEventModalContainerProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Container for AddEventModal (ADR-034).
 * Owns store access for the addCurrentEvent action.
 */
const AddEventModalContainer: React.FC<AddEventModalContainerProps> = ({ isOpen, onClose }) => {
  const actions = useActions();

  const handleAddEvent = async (text: string) => {
    await actions.addCurrentEvent(text);
  };

  return (
    <AddEventModal
      isOpen={isOpen}
      onClose={onClose}
      onAddEvent={handleAddEvent}
    />
  );
};

export default AddEventModalContainer;
